import React from 'react'
import Button from '../../../common/button/Button'

const LicenseCard = ({ totalSeats = 0, remainingSeats = 0 }) => {
    const handleManageLicenses = () => {

    }

    const handleBuyLicense = () => {

    }

    return (
        <>
            <div className="msync-card__body msync-card-group-buttons">
                <div className="msync-groups-buttons msync-no-margin">
                    <Button
                        className="msync-button--is-style-outline"
                        onClick={()=>handleManageLicenses()}
                    >
                        Manage Licenses
                    </Button>
                    <Button
                        onClick={()=>handleBuyLicense()}
                    >
                          Buy Licenses
                    </Button>
                </div>
                <div className='msync-group-buttons-totals'>
                    <span className='msync-group-buttons-total-label'>
                        Remaining licenses:
                        <span className='msync-group-buttons-total-content'> { remainingSeats }</span> |
                        Total licenses:
                        <span className='msync-group-buttons-total-content'> { totalSeats }</span>
                    </span>
                </div>
            </div>
        </>
    )
}

export default LicenseCard